import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestBannerLinksOrderPut = {
    path: "/banner-links/order",
    method: RouteHttpVerb.PUT
};
